// extracted by mini-css-extract-plugin
module.exports = {"box":"stat-box-module--box--3Ca0y","stat":"stat-box-module--stat--35-xH","text":"stat-box-module--text--MxAuB"};